import React from "react";

import { SitesEmissionsDTO } from "api/sites-emissions";
import { EsgEmissionSummaryIcon } from "assets";
import { Loading } from "components";

import { EmissionAllocationSummaryTab } from "./components";
import { ConsumptionSummary } from "./components/consumption-summary";
import { EmissionTableComponent, intensityColumns, locationBasedColumns, marketColumns } from "./components/site-emissions-table";

export const mainTabs = {
  INITIAL_TAB: "Summary",
};

export const SITES_EMISSIONS_PAGE = {
  ABSOLUTE_PATH: "/sites-emissions",
  TITLE: "Emissions Overview",
  ICON: <EsgEmissionSummaryIcon />,
  IS_TBD: false,
  renderMenu: false,
};

const getBaseTabs = (
  currentEmissionsData: SitesEmissionsDTO | null,
  loadingSitesEmissions: boolean,
  isDisaggregated: boolean,
  handleChangeIsDisaggregated: (isDisaggregated: boolean) => void,
  exportParams: any
) => [
    {
      label: "Summary",
      content: currentEmissionsData ? <ConsumptionSummary
        sitesEmissions={currentEmissionsData}
        isLoading={!(currentEmissionsData && !loadingSitesEmissions)}
      /> : <Loading />,
    },
    {
      label: "Location Based",
      content: loadingSitesEmissions ? <Loading /> : <EmissionTableComponent
        complementaryColumns={locationBasedColumns}
        isDisaggregated={isDisaggregated}
        setIsDisaggregated={handleChangeIsDisaggregated}
        tableData={currentEmissionsData?.siteAggregations}
        exportParams={exportParams}
      />,
    },
    {
      label: "Market Based",
      content: loadingSitesEmissions ? <Loading /> : <EmissionTableComponent
        complementaryColumns={marketColumns}
        isDisaggregated={isDisaggregated}
        setIsDisaggregated={handleChangeIsDisaggregated}
        tableData={currentEmissionsData?.siteAggregations}
        exportParams={exportParams}
      />,
    },
    {
      label: "Emissions Intensity",
      content: loadingSitesEmissions ? <Loading /> : <EmissionTableComponent
        complementaryColumns={intensityColumns}
        isDisaggregated={isDisaggregated}
        setIsDisaggregated={handleChangeIsDisaggregated}
        tableData={currentEmissionsData?.siteAggregations}
        exportParams={exportParams}
      />,
    }
  ];

export const getAllTabs = (
  isAdminUser: boolean,
  currentEmissionsData: SitesEmissionsDTO | null,
  loadingSitesEmissions: boolean,
  isDisaggregated: boolean,
  handleChangeIsDisaggregated: (isDisaggregated: boolean) => void,
  exportParams: any
) => {
  const baseTabs = getBaseTabs(currentEmissionsData, loadingSitesEmissions, isDisaggregated, handleChangeIsDisaggregated, exportParams);
  if (isAdminUser) {
    return [...baseTabs, {
      label: 'Emissions Allocation',
      content: <EmissionAllocationSummaryTab query={exportParams} />
    }]
  }
  return baseTabs;
}